import { types, Instance } from "mobx-state-tree";
import { SafeLocalStorageService } from "../../services/safeLocalStorageService";

enum FeatureKey {
  _placeholderFeature = "_placeholderFeature" // because it is very difficult to compile without any feature flags in store or enum
}
export const FeaturesStore = types
  .model("Features", {
    _placeholderFeatureEnabled: false
  })
  .actions((self) => {
    const isParamEnabled = (params: { [key: string]: string }, param: FeatureKey): boolean => {
      const paramEnabled = params[param];
      if (paramEnabled) {
        SafeLocalStorageService.getInstance().setItem(param, paramEnabled ? "true" : "false");
        return paramEnabled === "true";
      } else {
        return SafeLocalStorageService.getInstance().getItem(param) === "true";
      }
    };

    const actions = {
      processParams(params: { [key: string]: string }) {
        self._placeholderFeatureEnabled = isParamEnabled(params, FeatureKey._placeholderFeature);
      }
    };

    return actions;
  });

export interface IFeaturesStore extends Instance<typeof FeaturesStore> {}
